import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import { Icon } from "components/common";
import ClipboardButton from "components/common/ClipboardButton";
import useProductName from "brand-customization/useProductName";
const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const IconContainer = styled.div`
  margin: 3px 15px 0 0;
`;
const Description = styled.div`
  max-width: 700px;
`;
const Row = styled.div`
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const OrderedList = styled.ol`
  padding: 0;
  list-style: decimal inside none;
`;
const UnknownWidget = ({ config, type }) => {
  const { t } = useTranslation("widgets");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(IconContainer, null, /* @__PURE__ */ React.createElement(Icon, { name: "help", size: "3x" })), /* @__PURE__ */ React.createElement(Description, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement("strong", null, t("unknown_widget.title", { type }))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "unknown_widget.cannot_render", values: { type }, components: { strong: /* @__PURE__ */ React.createElement("strong", null) } })), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(OrderedList, null, /* @__PURE__ */ React.createElement("li", null, t("unknown_widget.missing_plugin")), /* @__PURE__ */ React.createElement("li", null, t("unknown_widget.legacy_dashboard")))), /* @__PURE__ */ React.createElement(Row, null, t("unknown_widget.what_to_do", { productName })), /* @__PURE__ */ React.createElement(Row, null, t("unknown_widget.copy_config"), " ", /* @__PURE__ */ React.createElement(
    ClipboardButton,
    {
      title: /* @__PURE__ */ React.createElement(Icon, { name: "content_copy", size: "sm" }),
      text: JSON.stringify(config, null, 2),
      bsSize: "xsmall"
    }
  ))));
};
export default UnknownWidget;
